module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_txt2_m.80938143abdb9c555d4ba41605ae37d6.png";